import { stringify } from 'qs'

// settings for creating the query string from an object
const stringifyOptions = {
  encodeValuesOnly: true,
  arrayFormat: 'repeat',
  sort: (a, b) => {
    return a.localeCompare(b)
  },
}

/**
 * Correctly format query string, handling filters, and stringifying the result
 * Copied from Zion record-details: https://github.com/fs-webdev/zion/blob/master/packages/record-search/src/search-results/resultsServices.js#L292-L308
 * @param queryObject
 * @returns {string}
 */
export function getQueryString(queryObject) {
  const queryCopy = { ...queryObject }
  const filters = queryCopy.filters || []
  let filterQuery = ''
  filters.forEach((param) => {
    const [key, value] = param.split('=')
    filterQuery = `${filterQuery}&${key}=${encodeURIComponent(value)}`
  })
  delete queryCopy.filters

  return `${stringify(queryCopy, stringifyOptions)}${filterQuery}`
}
